import apiService from './api';
import type { ApiResponse } from '../types/api';
import type {
  ContainerType,
  ContainerTypePayload,
  PropagationMethod,
  PropagationMethodPayload,
} from '../types/nurseryPropagation';

/**
 * The organisation's propagation set-up: methods and container types.
 * Anyone who records movements reads them; the nursery admin sets them up.
 */
class NurseryPropagationService {
  async getMethods(includeInactive = false): Promise<ApiResponse<PropagationMethod[]>> {
    return apiService.get(`/nursery/propagation-methods${includeInactive ? '?include_inactive=true' : ''}`);
  }

  async createMethod(data: PropagationMethodPayload): Promise<ApiResponse<PropagationMethod>> {
    return apiService.post('/nursery/propagation-methods', data);
  }

  async updateMethod(id: number, data: PropagationMethodPayload): Promise<ApiResponse<PropagationMethod>> {
    return apiService.put(`/nursery/propagation-methods/${id}`, data);
  }

  async getContainerTypes(includeInactive = false): Promise<ApiResponse<ContainerType[]>> {
    return apiService.get(`/nursery/container-types${includeInactive ? '?include_inactive=true' : ''}`);
  }

  async createContainerType(data: ContainerTypePayload): Promise<ApiResponse<ContainerType>> {
    return apiService.post('/nursery/container-types', data);
  }

  async updateContainerType(id: number, data: ContainerTypePayload): Promise<ApiResponse<ContainerType>> {
    return apiService.put(`/nursery/container-types/${id}`, data);
  }
}

export const nurseryPropagationService = new NurseryPropagationService();
export default nurseryPropagationService;
